"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTargetSizeByPercentage_1 = require("../editInfoUtils/getTargetSizeByPercentage");
var editInfo_1 = require("../editInfoUtils/editInfo");
/**
 * Check if the image is already resized to the given percentage
 * @param image The image to check
 * @param percentage The percentage to check
 */
function isResizedTo(image, percentage) {
    var editInfo = editInfo_1.getEditInfoFromImage(image);
    var _a = getTargetSizeByPercentage_1.default(editInfo, percentage), width = _a.width, height = _a.height;
    return (Math.round(width) == Math.round(editInfo.widthPx) &&
        Math.round(height) == Math.round(editInfo.heightPx));
}
exports.default = isResizedTo;
//# sourceMappingURL=isResizedTo.js.map